export default "__VITE_ASSET__4ae7e5b8__"